export default "__VITE_ASSET__6f3dc827__"